// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"43":"app-theme-dark0","234":"app-theme-dark1","653":"app-theme-light0","844":"app-theme-light1"}[chunkId] || chunkId) + "." + {"12":"0d7b7aab","43":"1006f903","204":"d2545dde","234":"52b31220","613":"9f1df967","653":"42d10209","844":"cdaca47e"}[chunkId] + ".chunk.js";
};